/* eslint-disable no-console */

import { useEffect, useState } from 'react';
import { useGetUserData, useSendData } from 'app/utils/services/useCreditService';

const useMainPage = () => {
  const [fin, setFin] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [creditTypeOptions, setCreditTypeOptions] = useState([
    {
      value: '',
      label: '',
    },
  ]);
  const [selectedCreditType, setSelectedCreditType] = useState<{ value: string; label: string }>(null);
  const [accNumber, setAccNumber] = useState('');
  const [endDate, setEndDate] = useState('');
  const [creditAmount, setCreditAmount] = useState('');
  const [mainCredit, setMainCredit] = useState('');
  const [perAmount, setPerAmount] = useState('');
  const [paidAmount, setPaidAmount] = useState('');
  const [cardBin, setCardBin] = useState('');
  const [amount, setAmount] = useState('');

  const { isLoadingGetUserData, getUserDataMutation, dataGetUserData } = useGetUserData();
  const { isLoadingSendData, sendDataMutation, dataSendData } = useSendData();

  useEffect(() => {
    if (dataGetUserData?.result !== 'error') {
      const typeOptions = dataGetUserData?.loans.map((item: any) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      setCreditTypeOptions(typeOptions);
      if (dataGetUserData?.loans.length === 1) {
        setSelectedCreditType({ value: dataGetUserData?.loans[0].id, label: dataGetUserData?.loans[0].name });
        setAccNumber(dataGetUserData?.loans[0].acc);
        setEndDate(dataGetUserData?.loans[0].open_date_string);
        setCreditAmount(dataGetUserData?.loans[0].amount);
        setMainCredit(dataGetUserData?.loans[0].main_balance);
        setPerAmount(dataGetUserData?.loans[0].int_balance);
        setPaidAmount(dataGetUserData?.loans[0].amount_to_be_paid);
      }
    }
  }, [dataGetUserData]);

  useEffect(() => {
    if (dataSendData?.url !== undefined) {
      window.location.href = dataSendData?.url;
    }
  }, [dataSendData]);

  const handleOnChangeFin = (e: any) => {
    setFin(e.target.value);
  };

  const handleOnChangeCustomerId = (e: any) => {
    setCustomerId(e.target.value);
  };

  const handleOnChangeCardBin = (e: any) => {
    setCardBin(e.target.value);
  };

  const handleOnChangeAmount = (e: any) => {
    const value = e.target.value;

    if (/^\d+(\.\d+)?$/.test(value)) {
      setAmount(value);
      }
  };

  const handleChangeCreditType = (newValue: any) => {
    setSelectedCreditType(newValue);
    setAccNumber(dataGetUserData?.loans.find((element: any) => element.id === newValue.value).acc);
    setEndDate(dataGetUserData?.loans.find((element: any) => element.id === newValue.value).open_date_string);
    setCreditAmount(dataGetUserData?.loans.find((element: any) => element.id === newValue.value).amount);
    setMainCredit(dataGetUserData?.loans.find((element: any) => element.id === newValue.value).main_balance);
    setPerAmount(dataGetUserData?.loans.find((element: any) => element.id === newValue.value).int_balance);
    setPaidAmount(dataGetUserData?.loans.find((element: any) => element.id === newValue.value).amount_montly);
  };

  const handleOnClick = () => {
    getUserDataMutation({
      data: {
        pin_code: fin,
        customer_id: customerId,
      },
    });
  };

  const handleOnClickSendData = () => {
    sendDataMutation({
      business_key: dataGetUserData?.business_key,
      data: {
        selected_loan_id: selectedCreditType.value,
        card_bin: cardBin,
        amount,
      },
    });
  };

  return {
    fin,
    customerId,
    handleOnChangeFin,
    handleOnChangeCustomerId,
    handleOnClick,
    dataGetUserData,
    selectedCreditType,
    creditTypeOptions,
    handleChangeCreditType,
    accNumber,
    endDate,
    creditAmount,
    mainCredit,
    perAmount,
    paidAmount,
    handleOnChangeCardBin,
    handleOnChangeAmount,
    handleOnClickSendData,
    cardBin,
    amount,
    isLoadingGetUserData,
    isLoadingSendData,
  };
};

export default useMainPage;
